import { StyleSheet, Text, View } from 'react-native'
import { Theme, ThemedView } from '@app/theme'
import { lightPalette } from '@app/theme/colors'
import { useTheme } from '@shopify/restyle'

const LinearProgressBar = ({ progress = 0 }: { progress: number }) => {
  const {colors} = useTheme<Theme>()

  return (
    <ThemedView>
        <ThemedView style={{ width: '100%', borderRadius: 3 , overflow: 'hidden', height: 6, backgroundColor: colors['bg-fill-emphasis-secondary'] }}>
            <ThemedView style={{ width: `${progress}%`, borderRadius: 3, overflow: 'hidden', height: 6, backgroundColor: colors['icon-emphasis-secondary'] }} />
        </ThemedView>
    </ThemedView>
  )
}

export default LinearProgressBar

const styles = StyleSheet.create({})